import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from '@env/environment';
import { enableProdMode } from '@angular/core';
import { LOGOUT_CHANNEL, LOGOUT_MESSAGE_TYPE } from '@services/logout-broadcast';

/** Страница, которую Keycloak открывает в скрытом iframe при выходе из любой системы. */
const FRONTCHANNEL_LOGOUT_PATH = '/frontchannel-logout';

/**
 * Выход по front-channel logout (#29347): стираем токены синхронно, до запуска Angular.
 *
 * Keycloak убирает iframe сразу по событию load. Приложение к этому моменту ещё проходит
 * инициализацию (проверка входа, обновление токена по сети), и компонент страницы не успевал
 * ничего стереть: следующий пользователь получал в PRSS токен прежнего и «Нет доступа к системе».
 * Записи библиотеки входа — ключи «<configId>-<clientId>» в localStorage и sessionStorage;
 * остальное (фильтры, настройки разделов) не трогаем. Открытые вкладки PRSS получают сигнал
 * и перезагружаются (App.remoteLogout$).
 */
function frontchannelLogout(): void {
    const suffix = `-${environment.keycloak.clientId}`;
    for (const storage of [localStorage, sessionStorage]) {
        Object.keys(storage)
            .filter((key) => key.endsWith(suffix))
            .forEach((key) => storage.removeItem(key));
    }

    try {
        const channel = new BroadcastChannel(LOGOUT_CHANNEL);
        channel.postMessage({ type: LOGOUT_MESSAGE_TYPE });
        channel.close();
    } catch {
        // Нет BroadcastChannel — вкладки узнают о выходе при следующем запросе.
    }
}

if (environment.production) {
    enableProdMode();
    console.log('Приложение запущено в режиме продакшена. ');
}
if (!environment.production) {
    console.log('Приложение запущено в режиме разработки.');
}

if (window.location.pathname === FRONTCHANNEL_LOGOUT_PATH) {
    frontchannelLogout();
} else {
    bootstrapApplication(App, appConfig).catch((err) => {
        if (err instanceof DOMException && err.name === 'InvalidStateError') {
            console.warn('Начальная навигация была прервана, приложение продолжает работать.');
            return;
        }
        console.error(err);
    });
}
